var map = {
	"./Home Page Gallery 4.webp": 52000,
	"./Home Page Gallery 6(1).webp": 47705,
	"./Home Page Gallery 6.webp": 12617,
	"./Home page gallery 1.webp": 93525,
	"./Home page gallery 3.webp": 96632,
	"./Home page galley 2.webp": 81373
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12106;